module.exports = "/assets/a619674eb180472226e267e2c6620b2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/V4.png
// module id = 1913
// module chunks = 0